export default "__VITE_ASSET__CwEfXa6m__"